import { render, staticRenderFns } from "./EventIFrame.vue?vue&type=template&id=f6428d52&"
import script from "./EventIFrame.vue?vue&type=script&lang=js&"
export * from "./EventIFrame.vue?vue&type=script&lang=js&"
import style0 from "./EventIFrame.vue?vue&type=style&index=0&id=f6428d52&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard,VCardText,VCardTitle})
